import { render, staticRenderFns } from "./OrderDetailTabTrakings.vue?vue&type=template&id=33220e50"
import script from "./OrderDetailTabTrakings.vue?vue&type=script&lang=js"
export * from "./OrderDetailTabTrakings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports